<template>
  <RouterView
    v-slot="{ Component }"
    name="SideModal"
  >
    <transition name="modal-slide">
      <div
        v-if="showSideModal"
        class="fixed bg-vp-base-100 border-l inset-y-0 right-0"
        :class="[widthClass, { 'overflow-auto': !disableScroll }]"
        style="z-index: 2000"
      >
        <component :is="Component" />
      </div>
    </transition>
  </RouterView>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed, watch } from 'vue';

const route = useRoute();
const showSideModal = computed(() => !!route.matched[0]?.components['SideModal']);
const widthClass = computed(() => route.meta.widthClass || 'w-2/3');

const disableScroll = computed(() => route.meta.disableScroll);

watch(showSideModal, () => {
  const bodyClassList = document.body.classList;

  if (showSideModal.value) {
    bodyClassList.add('modal-open');
  } else {
    bodyClassList.remove('modal-open');
  }
});
</script>
